import { Button, ButtonGroup } from '@material-ui/core';
import React from 'react';
import { LocalizationConfig } from '../../../config/app';
import { Loader } from './helpers';
import ShowIfRole from './ShowIfRole';
export default class TranslateInputSwitch extends React.PureComponent {
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */
    render() {
        const { translationLoading, currentLocale, changeLocale, performTranslationAction,
            value, toggleView, splitView } = this.props;
        return (
            <ButtonGroup size="small" variant="outlined" className='localization-input-switch-cont' >
                {!splitView && LocalizationConfig.locales.map((item) => {
                    return <Button key={item.code} onClick={changeLocale(item.code)} className={currentLocale !== item.code ? 'inactive-locale-btn' : ''}>{item.name}</Button>
                })}
                <ShowIfRole roles={['admin', 'super-admin', 'campaigns-manager', 'blog-manager','student']}>
                    {value && (currentLocale !== LocalizationConfig.default) && <Button
                        disabled={translationLoading}
                        key={'translation-action'}
                        color='primary'
                        onClick={performTranslationAction}>
                        {translationLoading ? <Loader size={20} /> : 'Translate'}
                    </Button> || ""}
                </ShowIfRole>
                {toggleView && <Button
                    onClick={toggleView}>
                    {!splitView ? 'Split View' : 'Mono View'}
                </Button>
                }
            </ButtonGroup>

        )
    }
}
